import { createColumnHelper } from "@tanstack/react-table";
import { Loader, Modal } from "semantic-ui-react";

import { ReactTable } from "components";
import { APIKeyLog, API_KEY_LOG_TYPES } from "models";
import { useApiReadingKeySearch, useApiReadingKeysLogs } from "modules/ApiKeys/service";
import { DATE_FORMATS_FNS, formatDate } from "util/dateHelpers";

type RequestLogsModalProps = {
  isOpen: boolean;
  requestLogsId: number;
  onClose: () => void;
};

export const RequestLogsModal = ({ isOpen, onClose, requestLogsId }: RequestLogsModalProps) => {
  const { data } = useApiReadingKeySearch();
  const { data: logs, isLoading } = useApiReadingKeysLogs(requestLogsId);

  const companyName = data?.find(k => k.id === requestLogsId)?.company_name;

  const columnHelper = createColumnHelper<APIKeyLog>();
  const columns = [
    columnHelper.accessor(row => row.username, {
      id: "action_by",
      header: "Action by",
      cell: info => <span>{info.renderValue()}</span>,
      size: 50
    }),
    columnHelper.accessor(row => row.created_on, {
      id: "action_at",
      header: "Action at",
      cell: info => {
        const value = info.renderValue();
        return <span>{value ? formatDate(value, DATE_FORMATS_FNS.dateMonthYear) : ""}</span>;
      },
      size: 50
    }),
    columnHelper.accessor(row => row.type, {
      id: "action",
      header: "Action",
      cell: ({ renderValue }) => <span>{renderValue() === API_KEY_LOG_TYPES.Revoke ? "Key Revoked" : "Key Shown"}</span>,
      size: 70
    }),
    columnHelper.accessor(row => row.reason, {
      id: "reason",
      header: "Reason",
      cell: info => <span>{info.renderValue()}</span>,
      size: 100
    })
  ];

  if (isLoading)
    return (
      <div className="CreateKeyModal__loader">
        <Loader active inline />
      </div>
    );

  return (
    <Modal className="CreateKeyModal" size="large" closeOnDimmerClick open={isOpen} onClose={onClose} closeIcon>
      <Modal.Header>
        <div className="CreateKeyModal__modal-header">
          <p>Request logs of {companyName}</p>
        </div>
      </Modal.Header>
      <Modal.Content scrolling>
        <ReactTable columns={columns} data={logs} renderEmptyRow={!logs?.length} emptyRowMessage="No data" />
      </Modal.Content>
    </Modal>
  );
};
